<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tjw6L7/tc-custom/9781488087028.jpg?1704273852707" alt="This image is the cover for the book Convenient Christmas Brides"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Convenient Christmas Brides
      </h1>
      <p class="bookDescription body article font2">
        <b>Christmas festivities come with the promise of wedding bells in this anthology of three charming Regency romance novellas!</b><br/><br/>In <i>Convenient Christmas Brides</i>, the holiday arrangements include marriage proposals that may just bring the gift of true love. In <i>The Captain’s Christmas Journey</i> by Carla Kelly, Captain Everard escorts Verity to her governess job—and for propriety’s sake that means a convenient engagement! In Louise Allen’s <i>The Viscount’s Yuletide Betrothal</i>, Eleanor advertises for a “suitable” gentleman to pose as her betrothed over Christmas. And in Laurie Benson’s novella, <i>Juliet Sommersby’s One Night Under the Mistletoe</i> leads to a marriage of convenience with handsome former love Lord Montague . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carla Kelly, Louise Allen, Laurie Benson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59918cea